<template>
  <div class="clearfix main_center" v-loading.fullscreen.lock="loading">

    <div class="right-content clearfix">


      <el-card class="box-card">
        <div slot="header" class="clearfix">
          <span>基本信息</span>
        </div>
        <el-form   label-width="152px" class="form viewFormWrapper">
          <el-row :gutter="15">
            <el-col :span="12">
              <el-form-item label="项目编号：" >{{ form.projectCode }} </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="项目名称：">{{ form.projectName }}    </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="15">
            <el-col :span="12">
              <el-form-item label="标段名称：" >{{ form.bidName }}   </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="招标人名称：" >{{ form.tenderName }}  </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="15">
            <el-col :span="12">
              <el-form-item label="招标代理机构：" >{{ form.tenderAgentName }} </el-form-item>
            </el-col>
          </el-row>
        </el-form>
      </el-card>


      <el-card class="box-card">
        <div slot="header" class="clearfix">
          <span>出证申请信息</span>
        </div>
        <el-form   label-width="152px" class="form viewFormWrapper">
          <el-row :gutter="15">
            <el-col :span="12">  <el-form-item label="申请单位：" >{{ questName }} </el-form-item></el-col>
            <el-col :span="12">  <el-form-item label="申请时间：" >{{ questTime }} </el-form-item></el-col>
          </el-row>
          <el-row :gutter="15">   <el-form-item label="申请出证原因:" style="width:90%;">
            <el-input type="textarea" v-model="questReason"  disabled></el-input>
          </el-form-item></el-row>
        </el-form>
      </el-card>

      <el-card class="box-card">
        <div slot="header" class="clearfix">
          <span>交易信息</span>
        </div>
        <el-form   label-width="152px" class="form viewFormWrapper">
          <el-row :gutter="15">
            <el-col :span="12">
              <el-form-item label="项目受理日期：">{{ form.projectHandleTime }}</el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="招标公告日期：" >{{ form.tenderNoticeTime }} </el-form-item>
            </el-col></el-row>
          <el-row :gutter="15">
            <el-col :span="12">
              <el-form-item label="招标文件获取时间：" >{{ form.tenderFileTime }} </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="评标专家抽取日期：">{{ form.evalprofExtractTime }}   </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="15">
            <el-col :span="12">
              <el-form-item label="开标日期：" >{{ form.bidopenTime }} </el-form-item>
            </el-col>
            <el-col :span="12" v-if="form.bidopenRooms.length>0">
              <el-form-item label="开标地点：" >
                    <span v-for="room in form.bidopenRooms" :key="room" style="margin-right: 10px;">
                         {{room }}
                    </span>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="15">
            <el-col :span="12">
              <el-form-item label="评标日期：" >{{ form.evalTime }}</el-form-item>
            </el-col>
              <el-col :span="12" v-if="form.evalRooms.length>0">
                <el-form-item label="评标地点：" >
                    <span v-for="room in form.evalRooms" :key="room">
                        {{room }}
                    </span>
                </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="15">
            <el-col :span="12">
              <el-form-item label="中标公示日期：" >{{ form.candidateTime }}   </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="中标公告日期：" >{{ form.resultNoticeTime }}  </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="15">
            <el-col :span="12">
              <el-form-item label="中标通知书发出日期：" >{{ form.noficationTime }}</el-form-item>
            </el-col>
          </el-row>
        </el-form>
      </el-card>


      <el-card class="box-card">
        <div slot="header" class="clearfix">
          <span>中标信息</span>
        </div>
        <el-form  label-width="152px" class="form viewFormWrapper"  style="flex-wrap: wrap;justify-content: space-between">
          <el-row :gutter="15">
            <el-col :span="12">
              <el-form-item label="中标人名称：" >{{ form.winerName }}</el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="中标金额：">{{ form.winBidprice }}  {{form.winPriceUnitName}} </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="15">
            <el-col :span="12">
              <el-form-item label="中标工期：" >{{ form.winWorkItem }} 天 </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="项目负责人：" >{{ form.winProjectMainer }} </el-form-item>
            </el-col>
          </el-row>
        </el-form>
      </el-card>


    </div>

    <div class="left-content">
      <div class="left-navbar">
          <el-button type="primary" plain size="small" style="margin-right:10px;" @click="routerCz()"  >出证</el-button>
          <el-button type="primary" plain size="small" style="margin-right:10px;" @click="processSubmit" >驳回</el-button>
          <el-button @click="back()" size="small" style="margin-left:0;">返回</el-button>
      </div>
    </div>

  </div>
</template>

<script>
    import {mapState} from "vuex";
    import {tabsCloseCurrentHandle} from '@/utils/routeTab';


    export default {
  components: {},
  data() {
    return {
      id: "",
      form: {
        id: '',
        projectCode: '',
        projectName:'',
        bidName:'',
        tenderName:'',
        tenderAgentName:'',
        projectHandleTime:'',
        tenderNoticeTime:'',
        tenderFileTime:'',
        evalprofExtractTime:'',
        bidopenAddress:'',
        bidopenTime:'',
        evalTime:'',
        evalAddress:'',
        candidateTime:'',
        resultNoticeTime:'',
        noficationTime:'',
        winerName:'',
        winBidprice:'',
        winWorkItem:'',
        winProjectMainer:'',
        winPriceUnit:'',
        winPriceUnitName:''
      },
      questName:'',  //申请单位
      questReason: '',  //申请出证原因
      questTime:'', //申请时间
      historyid:'',
      loading: false,
      user: '',
      pageSize: 10,//每页条数
      pageIndex: 1,//当前页
      total: 0,//总条数

      dataId: 0,
      formId: '',
      groupList: [],
      formInfo: {},
      tableData: [],


    }
  },

  filters: {},
  created() {

  },
  computed: {
    ...mapState({
      stateData: state => state.user
    })
  },

  activated() {

    // $route.query.id为首页通过 url跳转 带过来的参数
    this.id = (this.$route.query && this.$route.query.id) || (this.$route.params && this.$route.params.id) || '';
    this.getDetailById();
  },

  methods: {
    //列表查看进来根据id查询详情
    getDetailById() {

      if (this.id) {

        // 查询基本信息及流程id
        this.$http.get('/cateQuestBase/get?id=' + this.id).then(res => {
          if (res.data.code === '1') {
            const data = res.data.data;
            this.form = {...data};

            if (data.cateoutQuest!=undefined){
              this.questReason=data.cateoutQuest.questReason;
              this.questName=data.cateoutQuest.questName || this.stateData.displayName;
              this.questTime=data.cateoutQuest.questTime;
              this.historyid=data.cateoutQuest.historyid;
            }else{
              this.questName = this.stateData.displayName;
            }



          }
        })

      } else {
        this.$router.push({
          name: 'home'
        })
      }

    },


    // 返回
    back() {
      tabsCloseCurrentHandle();
      this.$router.push({
        name: 'cateout_quest_list'
      });
      this.clearData();
    },



    clearData() {
      this.questName='';
      this.questTime='';
      this.questReason='';
      this.historyid='';
    },


    //出证
    routerCz() {

      console.log("this.historyid"+this.historyid)
      this.$router.push({
        name: 'make_catequest_note',
        query:{
          id:this.id
        }
      });

      // if (this.historyid==-1){   //该数据为受理中状态，则跳到制作见证书页面生成pdf并可提交流程
      //   this.$router.push({
      //     name: 'make_catequest_note',
      //     query:{
      //       id:this.id
      //     }
      //   });
      // }else{    //该数据为已出证状态，则跳到出证查看表单页面可下载生成的pdf
      //   this.$router.push({
      //     name: 'download_catequest_note',
      //     query:{
      //       id:this.id
      //     }
      //   });
      // }

      this.clearData();
    },
      //提交流程
      processSubmit(){
          const params = {
              id:this.form.cateoutQuest.id,
              taskId:'',
              processinstanceid:this.form.cateoutQuest.processinstanceid,
              variables:{
                  commit:false
              }
          }
          this.$http.post('/cateOutQuest/processSubmit',params).then(res=>{
              if(res.data.code ==1){
                  this.$message({
                      type:'success',
                      message:'操作成功。'
                  })
                  this.back();
              }else{
                  this.$message({
                      type:'error',
                      message:'流程提交失败。'
                  })
              }
          })
      },




  },
  deactivated() {
  },


}
</script>

<style lang="less" scope>

.bidFileList {
  width: 100%;
  border: 1px solid #ebeef5;
  border-spacing: 0;
  border-collapse: collapse;
  text-align: center;

  th {
    border: 1px solid #ebeef5;
    height: 40px;
  }

  td {
    border: 1px solid #ebeef5;
    height: 30px;
  }
}


</style>
